import React, { useEffect } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import HeroBanner from './HeroBanner2';
import MissionTiles from './MissionTiles';
import About from './About';
import Solutions from './Solutions';
import Resources from './Resources';
import Contact from './Contact';
import mark from './assets/sustune_mark.png';
import './MainPage.css';

const MainPage = () => {
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <Navbar />

      <main>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <HeroBanner />
                <MissionTiles />
              </>
            }
          />
          <Route path="/about" element={<About />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>

      <footer className="site-footer">
        <div className="wrap footer-inner">
          <div className="footer-brand">
            <div className="footer-brand-row">
              <img src={mark} alt="" className="footer-logo" />
              <span className="wordmark-main light">Sustune</span>
              <span className="wordmark-sub">Technologies</span>
            </div>
            <p className="footer-tag">
              Sustainability, tuned into everything. Bengaluru, India.
            </p>
          </div>
          <nav className="footer-nav" aria-label="Footer">
            <Link to="/solutions">Solutions</Link>
            <Link to="/about">About</Link>
            <Link to="/resources">Resources</Link>
            <Link to="/contact">Contact</Link>
            <a href="mailto:info@sustunetech.com">info@sustunetech.com</a>
          </nav>
        </div>
        <div className="wrap footer-legal">
          <p>
            © {new Date().getFullYear()} Sustune Technologies. All rights
            reserved.
          </p>
        </div>
      </footer>
    </>
  );
};

export default MainPage;
